// extracted by mini-css-extract-plugin
export var statItem = "_e1-1";
export var statsRow = "_e1-0";